import { Injectable } from '@angular/core';
import {CommonService} from "@services/utils/common.service";
import {environment} from "../../../environments/environment";
import {PvUserSession} from "@models/user-session";
import {ApiHelperService} from "@services/apihelper/api-helper.service";

@Injectable({
  providedIn: 'root'
})
export class UserSessionService extends CommonService<PvUserSession, string> {

  protected API_URL : string = `${environment.URL_API}/pvusersession`;

  constructor(http: ApiHelperService) {
    super(http);
  }
}
